export default "__VITE_ASSET__CXS$skuG__"